import Icon from '../components/Icon.vue'

Icon.register({"square":{"width":448,"height":512,"paths":[{"d":"M400 32H48C21.5 32 0 53.5 0 80V432C0 458.5 21.5 480 48 480H400C426.5 480 448 458.5 448 432V80C448 53.5 426.5 32 400 32z"}]}})



//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-awesome/icons/square.js
// module id = null
// module chunks = 